import { hasKey } from '@witmetrics/utils/objects';
import { isInput } from '@/utils/dom';
import { HOTKEYS } from './constants';

export const classes = {
  wrapper: 'relative',
  controls:
    'z-10 absolute bottom-0 right-0 py-2 px-4 flex space-x-2 items-center',
  icon: 'text-3xl',
  rotationButton:
    'py-1 bg-grey-2 dark:bg-white/[0.06] hover:bg-grey-3 dark:hover:bg-white/[0.1] text-grey-7 dark:text-mauve-2 border-transparent shadow-card',
};

type SceneHotkey = keyof typeof HOTKEYS;

export function getHotkey(e: KeyboardEvent) {
  if (e.target && isInput(e)) return null;
  const key = e.key.toLowerCase();
  return hasKey(HOTKEYS, key) ? HOTKEYS[key as SceneHotkey] : null;
}
